import React, { useState, useEffect } from "react"
import { useHistory } from "react-router-dom"
import { isBlackFridayMidCampaignPopupActive } from "utils/dateUtils"
import { ENABLE_BLACK_FRIDAY_MID_CAMPAIGN_POPUP } from "config/campaignFeatureToggles"
import "./BlackFridayMidCampaignPopup.scss"

const BlackFridayMidCampaignPopup = () => {
  const [isVisible, setIsVisible] = useState(true)
  const history = useHistory()

  const STORAGE_KEY = "blackFridayMidCampaignPopup2025Dismissed"

  useEffect(() => {
    const wasClosed = sessionStorage.getItem(STORAGE_KEY)
    if (wasClosed === "true") {
      setIsVisible(false)
    }
  }, [])

  // Check feature toggle and date conditions
  if (!ENABLE_BLACK_FRIDAY_MID_CAMPAIGN_POPUP) return null
  if (!isBlackFridayMidCampaignPopupActive()) return null
  if (!isVisible) return null

  const handleClose = () => {
    setIsVisible(false)
    sessionStorage.setItem(STORAGE_KEY, "true")
  }

  const handleViewProducts = () => {
    const blackFridayUrl = '/shop/productlist?filters=%7B"FLT-CATEG001"%3A%5B"%2327616"%5D%7D&page=1&sortBy=ranking'
    history.push(blackFridayUrl)
    handleClose()
  }

  return (
    <div className="black-friday-mid-campaign-popup">
      <div className="black-friday-mid-campaign-popup__header">
        <h4 className="black-friday-mid-campaign-popup__title">
          🔥 Black Friday continuă!
        </h4>
        <button
          onClick={handleClose}
          className="black-friday-mid-campaign-popup__close-button"
          title="Închide"
        >
          ×
        </button>
      </div>
      <div className="black-friday-mid-campaign-popup__content">
        <p>
          Nu rata reducerile de până la 62%, cât încă mai sunt stocuri!
        </p>
        <button
          onClick={handleViewProducts}
          className="black-friday-mid-campaign-popup__cta-button"
        >
          Vezi produsele
        </button>
      </div>
    </div>
  )
}

export default BlackFridayMidCampaignPopup
